import { render, staticRenderFns } from "./StoreOpeningHours.vue?vue&type=template&id=57cffd62"
import script from "./StoreOpeningHours.vue?vue&type=script&lang=js"
export * from "./StoreOpeningHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports